<template>
    <tr>
        <td>
            <a :href="route('admin.companies.delivery-projects.addresses.show', [company, deliveryProject, address])">
                <span v-if="!!address.errors && !!address.errors.length" class="icon-circle is-md bg-danger">
                    <font-awesome-icon icon="exclamation-triangle" class="text-lg text-white pt-px" />
                </span>
                {{ address.full_address_with_apartment_number }}
            </a>
        </td>
        <td v-for="addressDeliveryPhase in address.delivery_phases_with_all_types">
            <address-delivery-phase
                v-if="address.is_signed"
                :initial-delivery-phase="addressDeliveryPhase"
                :company-phases="companyPhases"
                :can-edit="!! address.mac_address"
                inline-template
            >
                <div
                    v-if="isCompanyPhase(deliveryPhase.type)"
                    class="flex"
                >
                    <div v-if="deliveryPhase.completed" class="flex items-center">
                        <span class="icon-circle is-md bg-success">
                            <font-awesome-icon icon="check" class="text-lg text-white pt-px" />
                        </span>

                        <div class="ml-sm flex-none">
                            <div>{{ deliveryPhase.completed_at }}</div>
                        </div>

                        <edit-address-delivery-phase-button
                            :delivery-phase="deliveryPhase"
                            completed-classes="btn-icon"
                            @delivery-phase-updated="updateDeliveryPhase"
                        >
                            <font-awesome-icon icon="pencil" size="sm" />
                        </edit-address-delivery-phase-button>
                    </div>

                    <edit-address-delivery-phase-button
                        v-if="! deliveryPhase.completed && deliveryPhase.type !== 'activation' && (deliveryPhase.type !== 'installation' || canEdit)"
                        :delivery-phase="deliveryPhase"
                        uncompleted-classes="btn btn-md border border-neutral-dark text-neutral-dark is-ghost"
                        @delivery-phase-updated="updateDeliveryPhase"
                    />

                    <span v-if="! deliveryPhase.completed && deliveryPhase.type === 'activation'">
                        -
                    </span>
                </div>
                <div
                    v-else-if="deliveryPhase.type === 'activated'"
                >
                    <div v-if="deliveryPhase.completed" class="flex items-center">
                        <span class="icon-circle is-md bg-success">
                            <font-awesome-icon icon="check" class="text-lg text-white pt-px" />
                        </span>

                        <div class="ml-sm flex-none">
                            <div>{{ deliveryPhase.completed_at }}</div>
                        </div>
                    </div>

                    <span v-if="! deliveryPhase.completed">
                        -
                    </span>
                </div>
            </address-delivery-phase>
            <span v-else />
        </td>
    </tr>
</template>
<script>
    export default {
        props: {
            initialAddress: {
                type: Object,
                required: true,
            },
            company: {
                type: Object,
                required: true,
            },
            deliveryProject: {
                type: Object,
                required: true,
            },
            phases: {
                type: Array,
                required: true,
            },
            companyPhases: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                address: this.initialAddress,
                selected: false,
            };
        },
        created() {
            EventBus.$on('all-addresses-toggled', (toggled) => {
                this.selected = toggled;
                this.toggleItem();
            });
        },
        methods: {
            toggleItem() {
                this.$emit('toggleAddressSelected', this.address, this.selected);
            },
        },
    };
</script>
